import { createSlice } from '@reduxjs/toolkit'
import { IReapitContact, IReapitProperty } from '../../types/desktopProcess'

export type ReapitVariableKey = 'prpCode' | 'cntCode'

export type ReapitVariables = Partial<Record<ReapitVariableKey, string>>

interface CrmState {
  isUseAppFromCRM: boolean
  property?: IReapitProperty
  contact?: IReapitContact
  reapitVariables: ReapitVariables
}

const initialState: CrmState = {
  isUseAppFromCRM: false,
  reapitVariables: {},
}

export const crmSlice = createSlice({
  name: 'crm',
  initialState: initialState,
  reducers: {
    //
    setUseAppFromCRM(state: CrmState, action: { payload: { isCrm: boolean; variables: ReapitVariables } }) {
      state.isUseAppFromCRM = action.payload.isCrm
      state.reapitVariables = action.payload.variables
    },
    setProperty(state: CrmState, action: { payload: IReapitProperty }) {
      state.property = action.payload
    },
    setContact(state: CrmState, action: { payload: IReapitContact }) {
      state.contact = action.payload
    },
  },
})

export const { setUseAppFromCRM, setContact, setProperty } = crmSlice.actions

export default crmSlice.reducer
